import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { getVouchers } from "api/thunk/vouchers/getActions/getVouchers";
import { getVoucherByCorporateClient } from "api/thunk/vouchers/getActions/getVoucherByCorporateClient";
import { getStartkitVouchers } from "api/thunk/vouchers/getActions/getStartKitVouchers";
import { getDistancesByVoucher } from "api/thunk/vouchers/getActions/getDistancesByVoucher";
import { getVouchersPromocodes } from "api/thunk/vouchers/getActions/getVouchersPromocodes";
import { getVouchersPromocodesFree } from "api/thunk/vouchers/getActions/getVouchersPromocodesFree";
import { getVouchersUsersPromocodes } from "api/thunk/vouchers/getActions/getVouchersUsersPromocodes";
import { getVouchersById } from "api/thunk/vouchers/getActions/getVouchersById";
import { getVouchersCorpStartkit } from "api/thunk/vouchers/getActions/getVouchersCorpStartkit";
import { getVouchersPromocodesById } from "api/thunk/vouchers/getActions/getVouchersPromocodesById";
import { getVouchersPromocodesUnassignedCountPerDistance } from "api/thunk/vouchers/getActions/getVouchersPromocodesUnassignedCountPerDistance";
import { getSubvouchers } from "api/thunk/vouchers/getActions/getSubvouchers";
import { postVouchers } from "api/thunk/vouchers/postActions/postVouchers";
import { postVouchersPromocodes } from "api/thunk/vouchers/postActions/postVouchersPromocodes";
import { postVouchersAssignPromocodeByEmail } from "api/thunk/vouchers/postActions/postVouchersAssignPromocodeByEmail";
import { postVouchersPromocodeUnassign } from "api/thunk/vouchers/postActions/postVouchersPromocodeUnassign";
import { postVouchersSubvoucher } from "api/thunk/vouchers/postActions/postVouchersSubvoucher";
import { putVouchers } from "api/thunk/vouchers/putActions/putVouchers";
import { putVouchersResponsibleUser } from "api/thunk/vouchers/putActions/putVouchersResponsibleUser";
import { putVouchersSubvouchers } from "api/thunk/vouchers/putActions/putVouchersSubvouchers";
import { patchVouchersChangeStatus } from "api/thunk/vouchers/patchActions/patchVouchersChangeStatus";
import { deleteVouchersPromocodes } from "api/thunk/vouchers/deleteActions/deleteVouchersPromocodes";
import { deleteVouchers } from "api/thunk/vouchers/deleteActions/deleteVouchers";
import { deleteVouchersNonActivatedPromocodes } from "api/thunk/vouchers/deleteActions/deleteVouchersNonActivatedPromocodes";
import { deleteVouchersSubvouchers } from "api/thunk/vouchers/deleteActions/deleteVouchersSubvouchers";
import { getVouchersExcel } from "api/thunk/vouchers/getActions/getVouchersExcel";
import { getVouchersExportVoucherReportToExcel } from "api/thunk/vouchers/getActions/getVouchersExportVoucherReportToExcel";

const vouchersSlice = createSlice({
  name: "vouchers",
  initialState,
  reducers: {
    setVouchersPage: (state, action: PayloadAction<number>) => {
      state.vouchers.params.page = action.payload;
    },
    setVouchersPageSize: (state, action: PayloadAction<number>) => {
      state.vouchers.params.pageSize = action.payload;
      state.vouchers.params.page = 1;
    },
    setVauchersStatus: (state, action) => {
      state.vauchersStatus = action.payload;
    },
    setVouchersOrderBy: (state, action: PayloadAction<string>) => {
      state.vouchers.params.orderBy = action.payload;
      state.vouchers.params.page = 1;
    },
    setVouchersDirection: (state, action: PayloadAction<number>) => {
      state.vouchers.params.direction = action.payload;
      state.vouchers.params.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      //vouchers
      .addCase(getVouchers.pending, (state) => {
        state.vouchers.response.loading = true;
        state.vouchers.response.error = null;
      })
      .addCase(getVouchers.fulfilled, (state, action) => {
        state.vouchers.response.loading = false;
        state.vouchers.response.data = action.payload;
      })
      .addCase(getVouchers.rejected, (state, action) => {
        state.vouchers.response.loading = false;
        state.vouchers.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //voucher_by_corporate_client
      .addCase(getVoucherByCorporateClient.pending, (state) => {
        state.voucherByCorporateClient.response.loading = true;
        state.voucherByCorporateClient.response.error = null;
      })
      .addCase(getVoucherByCorporateClient.fulfilled, (state, action) => {
        state.voucherByCorporateClient.response.loading = false;
        state.voucherByCorporateClient.response.data = action.payload;
      })
      .addCase(getVoucherByCorporateClient.rejected, (state, action) => {
        state.voucherByCorporateClient.response.loading = false;
        state.voucherByCorporateClient.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //startkit_vouchers
      .addCase(getStartkitVouchers.pending, (state) => {
        state.startkitVouchers.response.loading = true;
        state.startkitVouchers.response.error = null;
      })
      .addCase(getStartkitVouchers.fulfilled, (state, action) => {
        state.startkitVouchers.response.loading = false;
        state.startkitVouchers.response.data = action.payload;
      })
      .addCase(getStartkitVouchers.rejected, (state, action) => {
        state.startkitVouchers.response.loading = false;
        state.startkitVouchers.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //distances_by_voucher
      .addCase(getDistancesByVoucher.pending, (state) => {
        state.distancesByVoucher.response.loading = true;
        state.distancesByVoucher.response.error = null;
      })
      .addCase(getDistancesByVoucher.fulfilled, (state, action) => {
        state.distancesByVoucher.response.loading = false;
        state.distancesByVoucher.response.data = action.payload;
      })
      .addCase(getDistancesByVoucher.rejected, (state, action) => {
        state.distancesByVoucher.response.loading = false;
        state.distancesByVoucher.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //vouchers_promocodes
      .addCase(getVouchersPromocodes.pending, (state) => {
        state.vouchersPromocodes.response.loading = true;
        state.vouchersPromocodes.response.error = null;
      })
      .addCase(getVouchersPromocodes.fulfilled, (state, action) => {
        state.vouchersPromocodes.response.loading = false;
        state.vouchersPromocodes.response.data = action.payload;
      })
      .addCase(getVouchersPromocodes.rejected, (state, action) => {
        state.vouchersPromocodes.response.loading = false;
        state.vouchersPromocodes.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //vouchers_promocodes_free
      .addCase(getVouchersPromocodesFree.pending, (state) => {
        state.vouchersPromocodesFree.response.loading = true;
        state.vouchersPromocodesFree.response.error = null;
      })
      .addCase(getVouchersPromocodesFree.fulfilled, (state, action) => {
        state.vouchersPromocodesFree.response.loading = false;
        state.vouchersPromocodesFree.response.data = action.payload;
      })
      .addCase(getVouchersPromocodesFree.rejected, (state, action) => {
        state.vouchersPromocodesFree.response.loading = false;
        state.vouchersPromocodesFree.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //vouchers_users_promocodes
      .addCase(getVouchersUsersPromocodes.pending, (state) => {
        state.vouchersUsersPromocodes.response.loading = true;
        state.vouchersUsersPromocodes.response.error = null;
      })
      .addCase(getVouchersUsersPromocodes.fulfilled, (state, action) => {
        state.vouchersUsersPromocodes.response.loading = false;
        state.vouchersUsersPromocodes.response.data = action.payload;
      })
      .addCase(getVouchersUsersPromocodes.rejected, (state, action) => {
        state.vouchersUsersPromocodes.response.loading = false;
        state.vouchersUsersPromocodes.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //vouchers_by_id
      .addCase(getVouchersById.pending, (state) => {
        state.vouchersById.response.loading = true;
        state.vouchersById.response.error = null;
      })
      .addCase(getVouchersById.fulfilled, (state, action) => {
        state.vouchersById.response.loading = false;
        state.vouchersById.response.data = action.payload;
      })
      .addCase(getVouchersById.rejected, (state, action) => {
        state.vouchersById.response.loading = false;
        state.vouchersById.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //voucher_corp_startkit
      .addCase(getVouchersCorpStartkit.pending, (state) => {
        state.vouchersCorpStartkit.response.loading = true;
        state.vouchersCorpStartkit.response.error = null;
      })
      .addCase(getVouchersCorpStartkit.fulfilled, (state, action) => {
        state.vouchersCorpStartkit.response.loading = false;
        state.vouchersCorpStartkit.response.data = action.payload;
      })
      .addCase(getVouchersCorpStartkit.rejected, (state, action) => {
        state.vouchersCorpStartkit.response.loading = false;
        state.vouchersCorpStartkit.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //vouchers_promocodes_by_id
      .addCase(getVouchersPromocodesById.pending, (state) => {
        state.vouchersPromocodesById.response.loading = true;
        state.vouchersPromocodesById.response.error = null;
      })
      .addCase(getVouchersPromocodesById.fulfilled, (state, action) => {
        state.vouchersPromocodesById.response.loading = false;
        state.vouchersPromocodesById.response.data = action.payload;
      })
      .addCase(getVouchersPromocodesById.rejected, (state, action) => {
        state.vouchersPromocodesById.response.loading = false;
        state.vouchersPromocodesById.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //get_vouchers_promocodes_unassigned_count_per-distance
      .addCase(
        getVouchersPromocodesUnassignedCountPerDistance.pending,
        (state) => {
          state.vouchersPromocodesUnassignedCountPerDistance.response.loading =
            true;
          state.vouchersPromocodesUnassignedCountPerDistance.response.error =
            null;
        }
      )
      .addCase(
        getVouchersPromocodesUnassignedCountPerDistance.fulfilled,
        (state, action) => {
          state.vouchersPromocodesUnassignedCountPerDistance.response.loading =
            false;
          state.vouchersPromocodesUnassignedCountPerDistance.response.data =
            action.payload;
        }
      )
      .addCase(
        getVouchersPromocodesUnassignedCountPerDistance.rejected,
        (state, action) => {
          state.vouchersPromocodesUnassignedCountPerDistance.response.loading =
            false;
          state.vouchersPromocodesUnassignedCountPerDistance.response.error =
            typeof action.payload === "string"
              ? action.payload
              : action.error.message || "Неизвестная ошибка";
        }
      )

      // get_subvouchers
      .addCase(getSubvouchers.pending, (state) => {
        state.subvouchers.response.loading = true;
        state.subvouchers.response.error = null;
      })
      .addCase(getSubvouchers.fulfilled, (state, action) => {
        state.subvouchers.response.loading = false;
        state.subvouchers.response.data = action.payload;
      })
      .addCase(getSubvouchers.rejected, (state, action) => {
        state.subvouchers.response.loading = false;
        state.subvouchers.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      // post_vouchers
      .addCase(postVouchers.pending, (state) => {
        state.postVouchers.loading = true;
        state.postVouchers.error = null;
      })
      .addCase(postVouchers.fulfilled, (state, action) => {
        state.postVouchers.loading = false;
        state.postVouchers.data = action.payload;
      })
      .addCase(postVouchers.rejected, (state, action) => {
        state.postVouchers.loading = false;
        state.postVouchers.error = action.error.message || "Неизвестная ошибка";
      })

      //post_vouchers_promocodes
      .addCase(postVouchersPromocodes.pending, (state) => {
        state.postVouchersPromocodes.loading = true;
        state.postVouchersPromocodes.error = null;
      })
      .addCase(postVouchersPromocodes.fulfilled, (state, action) => {
        state.postVouchersPromocodes.loading = false;
        state.postVouchersPromocodes.data = action.payload;
      })
      .addCase(postVouchersPromocodes.rejected, (state, action) => {
        state.postVouchersPromocodes.loading = false;
        state.postVouchersPromocodes.error =
          action.error.message || "Неизвестная ошибка";
      })

      //post_vouchers_assign_promocode_by_email
      .addCase(postVouchersAssignPromocodeByEmail.pending, (state) => {
        state.postVouchersAssignPromocodeByEmail.loading = true;
        state.postVouchersAssignPromocodeByEmail.error = null;
      })
      .addCase(
        postVouchersAssignPromocodeByEmail.fulfilled,
        (state, action) => {
          state.postVouchersAssignPromocodeByEmail.loading = false;
          state.postVouchersAssignPromocodeByEmail.data = action.payload;
        }
      )
      .addCase(postVouchersAssignPromocodeByEmail.rejected, (state, action) => {
        state.postVouchersAssignPromocodeByEmail.loading = false;
        state.postVouchersAssignPromocodeByEmail.error =
          action.error.message || "Неизвестная ошибка";
      })

      // post_vouchers_promocode_unassign
      .addCase(postVouchersPromocodeUnassign.pending, (state) => {
        state.postVouchersPromocodeUnassign.loading = true;
        state.postVouchersPromocodeUnassign.error = null;
      })
      .addCase(postVouchersPromocodeUnassign.fulfilled, (state, action) => {
        state.postVouchersPromocodeUnassign.loading = false;
        state.postVouchersPromocodeUnassign.data = action.payload;
      })
      .addCase(postVouchersPromocodeUnassign.rejected, (state, action) => {
        state.postVouchersPromocodeUnassign.loading = false;
        state.postVouchersPromocodeUnassign.error =
          action.error.message || "Неизвестная ошибка";
      })

      // post_vouchers_subvoucher
      .addCase(postVouchersSubvoucher.pending, (state) => {
        state.postVouchersSubvoucher.loading = true;
        state.postVouchersSubvoucher.error = null;
      })
      .addCase(postVouchersSubvoucher.fulfilled, (state, action) => {
        state.postVouchersSubvoucher.loading = false;
        state.postVouchersSubvoucher.data = action.payload;
      })
      .addCase(postVouchersSubvoucher.rejected, (state, action) => {
        state.postVouchersSubvoucher.loading = false;
        state.postVouchersSubvoucher.error =
          action.error.message || "Неизвестная ошибка";
      })

      // put_vouchers
      .addCase(putVouchers.pending, (state) => {
        state.putVouchers.loading = true;
        state.putVouchers.error = null;
      })
      .addCase(putVouchers.fulfilled, (state, action) => {
        state.putVouchers.loading = false;
        state.putVouchers.data = action.payload;
      })
      .addCase(putVouchers.rejected, (state, action) => {
        state.putVouchers.loading = false;
        state.putVouchers.error = action.error.message || "Неизвестная ошибка";
      })

      //put_vouchers_responsible_user
      .addCase(putVouchersResponsibleUser.pending, (state) => {
        state.putVouchersResponsibleUser.loading = true;
        state.putVouchersResponsibleUser.error = null;
      })
      .addCase(putVouchersResponsibleUser.fulfilled, (state, action) => {
        state.putVouchersResponsibleUser.loading = false;
        state.putVouchersResponsibleUser.data = action.payload;
      })
      .addCase(putVouchersResponsibleUser.rejected, (state, action) => {
        state.putVouchersResponsibleUser.loading = false;
        state.putVouchersResponsibleUser.error =
          action.error.message || "Неизвестная ошибка";
      })

      //put_vouchers_subvouchers
      .addCase(putVouchersSubvouchers.pending, (state) => {
        state.putVouchersSubvouchers.loading = true;
        state.putVouchersSubvouchers.error = null;
      })
      .addCase(putVouchersSubvouchers.fulfilled, (state, action) => {
        state.putVouchersSubvouchers.loading = false;
        state.putVouchersSubvouchers.data = action.payload;
      })
      .addCase(putVouchersSubvouchers.rejected, (state, action) => {
        state.putVouchersSubvouchers.loading = false;
        state.putVouchersSubvouchers.error =
          action.error.message || "Неизвестная ошибка";
      })

      //patch_vouchers_change_status
      .addCase(patchVouchersChangeStatus.pending, (state) => {
        state.patchVouchersChangeStatus.loading = true;
        state.patchVouchersChangeStatus.error = null;
      })
      .addCase(patchVouchersChangeStatus.fulfilled, (state, action) => {
        state.patchVouchersChangeStatus.loading = false;
        state.patchVouchersChangeStatus.data = action.payload;
      })
      .addCase(patchVouchersChangeStatus.rejected, (state, action) => {
        state.patchVouchersChangeStatus.loading = false;
        state.patchVouchersChangeStatus.error =
          action.error.message || "Неизвестная ошибка";
      })

      // delete_vouchers_promocodes
      .addCase(deleteVouchersPromocodes.pending, (state) => {
        state.deleteVouchersPromocodes.loading = true;
        state.deleteVouchersPromocodes.error = null;
      })
      .addCase(deleteVouchersPromocodes.fulfilled, (state, action) => {
        state.deleteVouchersPromocodes.loading = false;
        state.deleteVouchersPromocodes.data = action.payload;
      })
      .addCase(deleteVouchersPromocodes.rejected, (state, action) => {
        state.deleteVouchersPromocodes.loading = false;
        state.deleteVouchersPromocodes.error =
          action.error.message || "Неизвестная ошибка";
      })

      // delete_vouchers
      .addCase(deleteVouchers.pending, (state) => {
        state.deleteVouchers.loading = true;
        state.deleteVouchers.error = null;
      })
      .addCase(deleteVouchers.fulfilled, (state, action) => {
        state.deleteVouchers.loading = false;
        state.deleteVouchers.data = action.payload;
      })
      .addCase(deleteVouchers.rejected, (state, action) => {
        state.deleteVouchers.loading = false;
        state.deleteVouchers.error =
          action.error.message || "Неизвестная ошибка";
      })

      //delete_vouchers_non_activated_promocodes
      .addCase(deleteVouchersNonActivatedPromocodes.pending, (state) => {
        state.deleteVouchersNonActivatedPromocodes.loading = true;
        state.deleteVouchersNonActivatedPromocodes.error = null;
      })
      .addCase(
        deleteVouchersNonActivatedPromocodes.fulfilled,
        (state, action) => {
          state.deleteVouchersNonActivatedPromocodes.loading = false;
          state.deleteVouchersNonActivatedPromocodes.data = action.payload;
        }
      )
      .addCase(
        deleteVouchersNonActivatedPromocodes.rejected,
        (state, action) => {
          state.deleteVouchersNonActivatedPromocodes.loading = false;
          state.deleteVouchersNonActivatedPromocodes.error =
            action.error.message || "Неизвестная ошибка";
        }
      )

      //delete_vouchers_subvouchers
      .addCase(deleteVouchersSubvouchers.pending, (state) => {
        state.deleteVouchersSubvouchers.loading = true;
        state.deleteVouchersSubvouchers.error = null;
      })
      .addCase(deleteVouchersSubvouchers.fulfilled, (state, action) => {
        state.deleteVouchersSubvouchers.loading = false;
        state.deleteVouchersSubvouchers.data = action.payload;
      })
      .addCase(deleteVouchersSubvouchers.rejected, (state, action) => {
        state.deleteVouchersSubvouchers.loading = false;
        state.deleteVouchersSubvouchers.error =
          action.error.message || "Неизвестная ошибка";
      })

      //get_vouchers_excel
      .addCase(getVouchersExcel.pending, (state) => {
        state.getVouchersExcel.response.loading = true;
        state.getVouchersExcel.response.error = null;
      })
      .addCase(getVouchersExcel.fulfilled, (state, action) => {
        state.getVouchersExcel.response.loading = false;
        state.getVouchersExcel.response.data = action.payload;
      })
      .addCase(getVouchersExcel.rejected, (state, action) => {
        state.getVouchersExcel.response.loading = false;
        state.getVouchersExcel.response.error =
          action.error.message || "Неизвестная ошибка";
      })

      //get_vouchers_export_voucher_report_to_excel
      .addCase(getVouchersExportVoucherReportToExcel.pending, (state) => {
        state.getVouchersExportVoucherReportToExcel.response.loading = true;
        state.getVouchersExportVoucherReportToExcel.response.error = null;
      })
      .addCase(
        getVouchersExportVoucherReportToExcel.fulfilled,
        (state, action) => {
          state.getVouchersExportVoucherReportToExcel.response.loading = false;
          state.getVouchersExportVoucherReportToExcel.response.data =
            action.payload;
        }
      )
      .addCase(
        getVouchersExportVoucherReportToExcel.rejected,
        (state, action) => {
          state.getVouchersExportVoucherReportToExcel.response.loading = false;
          state.getVouchersExportVoucherReportToExcel.response.error =
            action.error.message || "Неизвестная ошибка";
        }
      );
  },
});

export const {
  setVouchersPage,
  setVouchersPageSize,
  setVauchersStatus,
  setVouchersDirection,
  setVouchersOrderBy
} = vouchersSlice.actions;
export default vouchersSlice.reducer;
